import { PortfolioHome } from "@/components/portfolio/PortfolioHome";

const Index = () => {
  return <PortfolioHome />;
};

export default Index;
